module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_mobile_01@2x-22be9d9d316993df722925d27121bbd6.jpg";